import React, { useEffect, useState } from 'react';
import SlidePanel from 'Components/SlidePanel/SlidePanel';
import UnitList from './UnitList';
import useTranslation from '../../../Hooks/useTranslation';

const ChangeUnitModal = (props) => {

    const {
        isOpen,
        onCancel,
        onSave,
        unitsRequest,
        licensesNames
    } = props;

    const translation = useTranslation();

    const { data: units, refetch } = unitsRequest;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        refetch().finally(() => setIsLoading(false));
    }, [isOpen, refetch]);

    return (
        <SlidePanel
            open={isOpen}
            onClose={onCancel}
            title={translation.changeUnitLabel}
            className="appSlidePanel--wide"
        >
            <UnitList
                submitButtonTitle={translation.saveButtonLabel}
                items={units}
                onCancel={onCancel}
                onSave={onSave}
                licensesNames={licensesNames}
                isLoading={isLoading}
                setsCurrentUnitModel={false}
            />
        </SlidePanel>
    );
};

export default ChangeUnitModal;
